<template>
  <div id="vue-container">
    <div class="box__header header--time">
      <div class="header--time__left">
        <h4>The most active users</h4>
        <br />
        <p>Total usage of the SkillCourt by user age group</p>
        <br />
        <output>{{ ageRange }}</output>
        <br />
      </div>

      <div class="header--time__right">
        <div class="char-label">
          <span class="color-square" id="youngest"></span>
          <p>0-12</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="twelve"></span>
          <p>12-18</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="eighteen"></span>
          <p>18-25</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="twenty-five"></span>
          <p>25-30</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="thirty"></span>
          <p>30-40</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="forty"></span>
          <p>40-50</p>
        </div>
        <div class="char-label">
          <span class="color-square" id="fifty"></span>
          <p>+50</p>
        </div>
      </div>
    </div>
    <div class="user-line-chart-container" style="background: none">
      <v-chart :options="option" :autoresize="true" id="bar-chart"></v-chart>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import { mapGetters } from "vuex";

export default {
  name: "sdcs",
  data() {
    return {
      ageRange: "",
      option: {}
    };
  },
  components: {
    "v-chart": ECharts
  },
  computed: {
    ...mapGetters(["getActivityResults"])
  },
  methods: {
    drawGraph() {
      this.option = {
        // color: [ "#bdfced", "#7ef5da" , "#43dbc9", "#1b9ba0", "#1378ba" ,"#105c8e"],
        color: [
          "#105c8e",
          "#1378ba",
          "#1b9ba0",
          "#43dbc9",
          "#7ef5da",
          "#bdfced"
        ],

        radius: [0, "10%"],
        // backgroundColor: "#353535",
        backgroundColor: "#383838",

        barWidth: 25,
        silent: true,
        animationDuration: 0,

        grid: {
          show: false,
          left: "4%",
          right: "3%",
          top: "0%",
          bottom: "1%",
          width: "100%",
          height: "100%",
          containLabel: true
        },
        xAxis: {
          show: true,
          type: "category",
          data: [
            "00",
            "",
            "",
            "03",
            "",
            "",
            "06",
            "",
            "",
            "09",
            "",
            "",
            "12",
            "",
            "",
            "15",
            "",
            "",
            "18",
            "",
            "",
            "21",
            "",
            "",
            "24"
          ],
          color: "#fff",
          boundaryGap: true,
          min: 0,
          max: 24,
          scale: false,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          },

          axisLabel: {
            show: true,
            interval: 2,
            color: "#aaaaaa",
            // fontFamily:
            margin: 12
          }
        },
        yAxis: {
          type: "value",
          label: { show: false },
          boundaryGap: false,
          offset: -4,
          splitNumber: 5,
          min: 0,
          // max:2600,
          axisLine: { show: false },
          itemStyle: {
            barBorderRadius: [15, 15, 15, 15]
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#747474",
              type: "dashed",
              width: 1
              // ///
              // color: "#aaa",
              // type: "dashed",
              // width: 1,
              // // shadowBlur: 3,
              // shadowColor: "#747474",
              // // opacity:0.6,
            }
          },

          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },

        series: [
          {
            name: "50+",
            type: "bar",
            stack: "xx",
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },

            data: this.getActivityResults[6]
          },
          {
            name: "50",
            type: "bar",
            stack: "xx",
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },

            data: this.getActivityResults[5]
          },
          {
            name: "40",
            type: "bar",
            stack: "xx",
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },

            data: this.getActivityResults[4]
          },
          {
            name: "30",
            type: "bar",
            stack: "xx",
            barBorderRadius: 50,
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },
            data: this.getActivityResults[3]
          },
          {
            name: "18-25",
            type: "bar",
            stack: "xx",
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },

            data: this.getActivityResults[2]
          },
          {
            showBackground: true,
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },
            backgroundStyle: {
              color: "#ffffff",
              opacity: 0.04,
              shadowBlur: 1
            },
            name: "12-18",
            type: "bar",
            stack: "xx",

            data: this.getActivityResults[1]
          },
          {
            showBackground: true,
            itemStyle: { barBorderRadius: [5, 5, 0, 0] },
            backgroundStyle: {
              color: "#ffffff",
              opacity: 0.04,
              shadowBlur: 1
            },
            name: "0-12",
            type: "bar",
            stack: "xx",

            data: this.getActivityResults[0]
          }
        ]
      };
    }
  },
  mounted() {
    this.drawGraph();
  },
  watch: {
    getActivityResults() {
      this.drawGraph();
    }
  }
};
</script>

<style lang="scss" scoped>
.box__header {
  justify-content: space-between;
}
.user-line-chart-container {
  border: red;
  margin: 0 30px 0 0;
  height: 248px;
}
.header--time {
  height: 175px;
  padding: 40px 30px 0px 37px;
  background-color: #383838;
  display: block;
  display: flex;
  font-family: Montserrat-SemiBold;
  margin-bottom: 70px;
}
.header--time:hover {
  cursor: default;
}
.header--time__left {
  display: flex;
  flex-direction: column;
  //width: 300px;
  background-color: #383838;
}
.header--time__right {
  display: flex;
  flex-direction: column;
  // width: 235px;
  text-align: right;
  background-color: #383838;
  // margin-left: 300px;
}
.box__header h4 {
  font-size: 18px;
  margin-top: 14px;
}
.box__header p {
  font-size: 14px;
  opacity: 0.7;
  color: #c3c3c3;
  font-family: Montserrat-Regular;
  margin: 2 px 0 12px 0;
}
.box__header output {
  font-size: 30px;
  background-color: #383838;
  display: inline-block;
}
.char-label {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  background-color: #383838;
  margin: 0 0px 9px 0;
}
.color-square {
  border-radius: 0;
  width: 16px;
  height: 8px;
  margin: 0 0px 0 8px;
}
#youngest {
  background-color: #d8fdf5;
}
#twelve {
  background-color: #bdfced;
}
#eighteen {
  background-color: #7ef5da;
}
#twenty-five {
  background-color: #43dbc9;
}
#thirty {
  background-color: #1b9ba0;
}
#forty {
  background-color: #1378ba;
}
#fifty {
  background-color: #105c8e;
}
</style>
